import {updateField} from "vuex-map-fields"
import {getDefaultState} from "./documentTypeState"

export default {
	updateField,
	RESET_STATE(state) {
		Object.assign(state, getDefaultState())
	},
	SET_DOCUMENT_TYPES(state, payload) {
		state.document_types = payload
	},
	SET_DOCUMENT_TYPE(state, payload) {
		state.document_type = payload
	},
	SET_VALIDATION_ERRORS(state, payload) {
		for (const key in payload) {
			state.validation_document_type[key] = '* '+payload[key][0]
		}
	},
	CLEAR_VALIDATION(state) {
		for (const key in state.validation_document_type) {
			state.validation_document_type[key] = null
		}
	},
}
